import { createSlice } from '@reduxjs/toolkit';

import { addToCartFailed, addToCartStarted, addToCartSucceeded, initSucceeded } from '../../actions/priceMatrixActions';

// `roomGroupSelected` is the only action here no thunk dispatches, so it is the only one that can
// be slice-generated without an import cycle with the actions module.
//
// The three add-to-cart cases previously read `loading` off the action, which every call site set
// to true, false and false respectively. The slice decides it now; the outcome is identical for
// every dispatch that exists.
const hotelDataSlice = createSlice({
  name: 'hotelData',
  initialState: null,
  reducers: {
    roomGroupSelected: (state, action) => ({ ...state, selectedRoomGroup: action.payload }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(initSucceeded, (_state, action) => {
        const { roomGroups, hotelData, roomGroupKeyFromUrl } = action.payload;

        let selectedRoomGroup = null;
        const roomGroupsWithPrices = roomGroups?.some((room) => room.priceBreakDowns);

        if (roomGroups && roomGroupsWithPrices) {
          const availableRoomGroups = [...roomGroups].filter((roomGroup) => roomGroup.priceBreakDowns !== null);

          selectedRoomGroup =
            availableRoomGroups.find(
              (roomGroup) =>
                roomGroup.bookingEngineRoomGroupKey === (hotelData?.selectedRoomGroupKey || roomGroupKeyFromUrl),
            ) || availableRoomGroups[0];
        }

        return {
          ...hotelData,
          roomGroups,
          selectedRoomGroup,
          noPrices: !roomGroupsWithPrices,
        };
      })
      .addCase(addToCartStarted, (state) => ({ ...state, loading: true }))
      .addCase(addToCartFailed, (state) => ({ ...state, loading: false }))
      .addCase(addToCartSucceeded, (state) => ({ ...state, loading: false }));
  },
});

export const { roomGroupSelected } = hotelDataSlice.actions;

export default hotelDataSlice.reducer;
